import { render, staticRenderFns } from "./importRole.vue?vue&type=template&id=6b5a625d"
import script from "./importRole.vue?vue&type=script&lang=js"
export * from "./importRole.vue?vue&type=script&lang=js"
import style0 from "./importRole.vue?vue&type=style&index=0&id=6b5a625d&prod&lang=scss"
import style1 from "./importRole.vue?vue&type=style&index=1&id=6b5a625d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports